import type { WhitelabelAccountBrandingStatus as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';

/** One account attached to a whitelabel config, as the status read reports it — not `Internal/Account`. */
export type BrandedAccount = {
  accountId: number;
  name?: string;
};

export const fromGql = (item: GQLItem): BrandedAccount => ({
  ...take<BrandedAccount>(item, 'accountId'),
  name: item.name ?? undefined,
});

export const fromGqlCollection = (items: GQLItem[]): BrandedAccount[] => items.map(fromGql);
